import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import { InvitationDetails } from './useInvitationDetails';

/** Validity in the business card's status box: green, or amber in the last day. */
export default function InvitationValidity({
  details,
}: {
  details: InvitationDetails;
}): JSX.Element {
  const { t } = useTranslation();
  const urgent = details.daysLeft < 1;
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        p: 2,
        borderRadius: 1,
        bgcolor: urgent ? 'warning.lighter' : 'success.lighter',
      }}
    >
      <Iconify
        icon="solar:clock-circle-bold-duotone"
        sx={{ color: urgent ? 'warning.dark' : 'success.main', flexShrink: 0 }}
      />
      <Typography
        variant="body2"
        sx={{ color: urgent ? 'warning.darker' : 'success.dark' }}
      >
        {details.validity}
        {', '}
        {t('invitationAcceptance.validUntil').toLowerCase()} {details.expiresAt}
      </Typography>
    </Stack>
  );
}
